import PropTypes from 'prop-types';
import React from 'react';

import SEOLink from '../SEOLink';

const CanonicalLink = ({ path }) => {
  return <SEOLink rel="canonical" path={path} addOpenGraphTag />;
};

CanonicalLink.propTypes = {
  path: PropTypes.string.isRequired,
};

export default CanonicalLink;
